module.exports = __webpack_public_path__ + "img/default_food.ec18955a.svg";